import { render, staticRenderFns } from "./DialogAuthCurrentUser.vue?vue&type=template&id=ff1c7ac0&"
import script from "./DialogAuthCurrentUser.vue?vue&type=script&lang=js&"
export * from "./DialogAuthCurrentUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff1c7ac0')) {
      api.createRecord('ff1c7ac0', component.options)
    } else {
      api.reload('ff1c7ac0', component.options)
    }
    module.hot.accept("./DialogAuthCurrentUser.vue?vue&type=template&id=ff1c7ac0&", function () {
      api.rerender('ff1c7ac0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/DialogAuthCurrentUser.vue"
export default component.exports